export const Reciept = ({
  height = "16",
  width = "16",
}: {
  height?: string;
  width?: string;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.5 15.9333L12.058 14.2593L10.282 15.476L8.50467 14.2587L6.72733 15.4747L4.94667 14.2573L2.5 15.9333V2C2.5 1.46957 2.71071 0.960859 3.08579 0.585786C3.46086 0.210714 3.96957 0 4.5 0L12.5 0C13.0304 0 13.5391 0.210714 13.9142 0.585786C14.2893 0.960859 14.5 1.46957 14.5 2V15.9333ZM4.94667 12.6413L6.72667 13.8587L8.50467 12.6413L10.282 13.8587L12.0587 12.6407L13.1667 13.4V2C13.1667 1.82319 13.0964 1.65362 12.9714 1.5286C12.8464 1.40357 12.6768 1.33333 12.5 1.33333H4.5C4.32319 1.33333 4.15362 1.40357 4.0286 1.5286C3.90357 1.65362 3.83333 1.82319 3.83333 2V13.4L4.94667 12.6413Z"
      fill="#706A85"
    />
    <path d="M11.8332 5.33301H5.1665V6.66634H11.8332V5.33301Z" fill="#706A85" />
    <path d="M10.4998 8H5.1665V9.33333H10.4998V8Z" fill="#706A85" />
  </svg>
);
